export default __webpack_public_path__ + "static/media/Dr. Somali Das.85bc7c3b.png";